export const GreyDot = () => (
  <div
    css={theme => ({
      width: 10,
      height: 10,
      backgroundColor: theme.semantic.ColorContentDisabled,
      border: `1px solid ${theme.semantic.ColorContentDisabled}`,
      borderRadius: '100%',
      boxShadow: '1px 1px 2px 0px rgba(0, 0, 0, 0.25)',
    })}
  />
)
